import ReactDatePicker from 'react-datepicker'

import { InputCalendar } from '../InputCalendar'

import 'react-datepicker/dist/react-datepicker.css'
import './style.css'

export type DateType = Date | null

type MonthPickerProps = {
  selected: string
  onChange: (date: Date) => void
  size?: 'sm' | 'md'
}

export const MonthPicker = (props: MonthPickerProps) => {
  const { selected, onChange, size = 'md' } = props
  const [month, year] = selected.split('/')

  return (
    <ReactDatePicker
      selected={
        !!selected
          ? new Date(parseInt(year), parseInt(month) - 1, 1)
          : undefined
      }
      onChange={onChange}
      showMonthYearPicker
      dateFormat="MM/yyyy"
      enableTabLoop={false}
      customInput={<InputCalendar size={size} />}
    />
  )
}
